import "./LegacyExpeditionSuite.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Modules from "./sections/Modules";
import Guarantee from "./sections/Guarantee";
import Upgrade from "./sections/Upgrade";
import Footer from "@/reusable_sections/Footer";
export default function LegacyExpeditionSuitePage() {
  return <div>
      <Header />
      <Hero />
      <Modules />
      <Guarantee />
      <Upgrade />
      <Footer />
    </div>;
}